"use strict";

import jQuery from 'jquery';

/**
 * Geocoder-Typen
 *
 * @enum {string}
 */
gc.gis.module.GCLocatorGroup = {
	GEOMETRY:   'geometry',
	INTERNAL:   'internal',
	WEBSERVICE: 'webservice'
};

/**
 * @classdesc
 * Gehe-Zu-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen.
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}] Kartenreferenz.
 * @param {string} options.label Label
 * @param {Array<Object>} options.coders Liste von Geocoder-Konfigurationen
 * @param {boolean} options.preload
 * @param {number} options.autocompleteLength Default-Wert für nicht vorhandene Geocoder-Konfig-Optionen
 * @param {string} options.requests.geocoderGetAllUrl
 */
gc.gis.module.GCLocator = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	this.options                  = options;
	this.map                      = options.map || gc.gis.iface.map;
	this.label                    = options.label || 'Gehe zu';
	this.coders                   = [];

	this._last_coder_selection    = '';
	this._current_coder_selection = '';

	this._initCoders();
	this._initUI();
};
gc.gis.module.GCLocator.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 * Initialisiert die konfigurierten Coder.
 *
 * @protected
 * @method
 */
gc.gis.module.GCLocator.prototype._initCoders = function()
{
	this.coders = [];

	for( var i=0; i<this.options.coders.length; i++ )
	{
		var config = this.options.coders[i];
		config.module  = this;
		config.map     = this.map;
		config.preload = this.options.preload === true || false;
		// Ggf. autocompleteLength überschreiben
		if( !config.autocompleteLength )
		{
			config.autocompleteLength = this.options.autocompleteLength;
		}

		var coder = undefined;
		if( config.group === gc.gis.module.GCLocatorGroup.INTERNAL )
		{
			coder = new gc.gis.module.GCLocator.Geocoder( config );
		}
		else if( config.group === gc.gis.module.GCLocatorGroup.GEOMETRY )
		{
			if( config.type === 'coordinate')
			{
				coder = new gc.gis.module.GCLocator.Coordinate( config );
			}
			// else if( config.type === 'marker')
			// {
			//	coder = new gc.gis.module.GCLocator.Marker( config );
			// }
		}
		else if( config.group === gc.gis.module.GCLocatorGroup.WEBSERVICE )
		{
			if( config.type === 'nominatim')
			{
				coder = new gc.gis.module.GCLocator.NominatimGeocoder( config );
			}
			// else if( config.type === 'google')
			// {
			// 	coder = new gc.gis.module.GCLocator.Google( config );
			// }
		}

		if( coder )
		{
			this.coders.push( coder );
		}
		else
		{
			gc.gis.iface.log.error( this, new gc.gis.error.GCError('Failed to setup geocoder of type '+ config.type +' in group '+ config.group) );
		}
	}
};

/**
 * Initialisiert die UI-Komponenten: ein Haupt-Panel und für jeden Coder ein
 * eigenes, mit dem Haupt-Panel als <code>parent</code>
 *
 * @protected
 * @method
 */
gc.gis.module.GCLocator.prototype._initUI = function()
{
	var self = this;

	this._render();

	// Haupt-Panel
	this._content_main = new gc.gis.ui.GCSidebarContent({
		label:    this.label,
		'parent': null,
		element:  this.getElement()
	});

	this.launcher = {
		label: this.label,
		//icon: 'glyphicon glyphicon-flag',
		icon: 'glyphicon glyphicon-map-marker',
		content: this._content_main
	};
	gc.gis.iface.ui.sidebar.addLauncher( this.launcher );

	// Coder gruppieren
	var groups = {};
	var list = [];

	for( var i=0; i<this.coders.length; i++ )
	{
		var group = groups[this.coders[i].group];
		if( !group )
		{
			group = {
				label: this.__getGroupLabel( this.coders[i].group ),
				coders: []
			}
			groups[this.coders[i].group] = group;
		}
		group.coders.push( this.coders[i] );
	}

	// Formular zusammenfriemeln
	var form_config = {
		controls: []
	};

	var group_keys = Object.keys( groups );
	for( var i=0; i<group_keys.length; i++ )
	{
		var group = groups[group_keys[i]];

		var control_advanced = {
			label: group.label,
            type: 'advanced',
			active: true,
			tooltip: group.label,
			controls: []
		};

		for( var j=0; j<group.coders.length; j++ )
		{
			var fn = function( coder ) {
				return gc.gis.iface.ui.sidebar.createSubmenuItem({
					label: coder.label,
					click: function( evt ) {
						gc.gis.iface.ui.sidebar.setContent( new gc.gis.ui.GCSidebarContent({
							label: 'Gehe zu: '+ coder.label,
							parent: self.launcher.content,
							launcher: self.launcher.element,
							element: coder.getElement()
						}) )
					}
				});
			};

			control_advanced.controls.push({
				type: 'custom',
				element: fn( group.coders[j] )
			});
		}

		if( group.coders.length > 0 )
		{
            form_config.controls.push( control_advanced );
		}
	}
	this.getElement().append(
		gc.gis.util.GCFormRenderer.renderFormContent( form_config )
	);
};

/**
 * @public
 * @method
 * @returns {jQuery}
 */
gc.gis.module.GCLocator.prototype.getElement = function()
{
	if( !this.element )
	{
		this._render();
	}
	return this.element;
};

/**
 * @protected
 * @method
 */
gc.gis.module.GCLocator.prototype._render = function()
{
	this.element = jQuery('<div>', {
		'class': 'gc-geocoder'
	});

	return this.element;
};

/**
 * Gibt ein menschenlesbares Label für bekannte Coder-Gruppen zurück. Falls
 * der Gruppenschlüssel nicht bekannt ist, wird er selbst zurückgegeben.
 *
 * @private
 * @method
 * @param {gc.gis.module.GCLocatorGroup} key
 *   <code>geometry</code>, <code>internal</code> oder <code>webservice</code>
 * @returns {string}
 */
gc.gis.module.GCLocator.prototype.__getGroupLabel = function( key )
{
	var dict = {
		geometry:   'Geometrie',
		internal:   'Verortungsdienste',
		webservice: 'Webdienste'
	};

	return dict[key] || key;
};
